import { Button, Spinner } from 'react-bootstrap';
import TextTruncate from 'react-text-truncate';
import DataDownload from '../DataDownload';
import DownloadStatus from '../DownloadStatus';
import CLM from '../../images/CLMLogo.png';
import ITS from '../../images/treatmentTrackerIcon2.webp';
import SCIRP from '../../images/CWFRTF_logo_badge_clr.png';
import { useState } from 'react';
import { formatTitle } from '../../util/TitleHelper';

const ListCardBasic = (props) => {
  const {
    dataset,
    inWorkspace: checkInWorkspace,
    addToWorkspace,
    removeFromWorkspace,
  } = props;
  const [loading, setLoading] = useState(false);
  const [downloadStatus, setDownloadStatus] = useState(null);
  const [downloadError, setDownloadError] = useState(null);
  const inWorkspace = checkInWorkspace(dataset);

  const itemGis = props.getGisService(dataset);
  const isBoundary =
    itemGis && itemGis?.layer_name.search('boundary') !== -1 ? true : false;
  const isITS =
    itemGis && itemGis?.layer_name.search('ITS:') !== -1 ? true : false;
  // SCIRP datasets get the Task Force badge (icon only - not ITS behavior).
  const isSCIRP = dataset.extras?.some(
    (e) =>
      e.key === 'collection_name' &&
      e.value === 'Southern California Ignition Reduction Program'
  );

  const handleView = () => {
    window.open(`/catalog/${dataset.name}`, '_blank');
    // props.setModalData(dataset);
    // props.setModalShow(true);
  };
  const handleDownload = async () => {
    setLoading(true);
    setDownloadError(null);
    try {
      await DataDownload(dataset, { onStatus: setDownloadStatus });
    } catch (error) {
      console.error(error);
      setDownloadError(error.message);
    } finally {
      setDownloadStatus(null);
      setLoading(false);
    }
  };

  const handleApisView = () => {
    props.setAPIsModalData(dataset);
    props.setAPIsModalShow(true);
  };

  return (
    <div className="page_layout_1" style={{ width: 'auto' }}>
      <div className="img_background" aria-hidden="true">
        {isITS ? (
          <img className="img_its" src={ITS} alt="Its logo" />
        ) : isSCIRP ? (
          <img className="img_scirp" src={SCIRP} alt="SCIRP logo" />
        ) : !isBoundary ? (
          <img className="img_clm" src={CLM} alt="Clm logo" />
        ) : (
          <img
            className="img_boundary"
            alt="boundary image"
            src={
              `${process.env.REACT_APP_API_URL}/Utility/wms_thumbnail?wms_url=` +
              itemGis.service_url +
              `&layer_name=` +
              itemGis.layer_name.split(':')[1] +
              `&width=200&height=200`
            }
          />
        )}
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          marginBottom: '1rem',
        }}
      >
        <p
          style={{
            fontSize: '16px',
            fontWeight: 'bolder',
            marginBottom: '0',
          }}
        >
          {formatTitle(dataset.title)}
        </p>

        <TextTruncate
          line={2}
          element="span"
          truncateText="…"
          text={dataset.notes}
          style={{ fontSize: '13px', marginBottom: '4px' }}
        />

        <div className="card_buttons" style={{ marginBottom: '2px' }}>
          <Button
            className="btn_primary"
            onClick={handleView}
            disabled={!itemGis}
          >
            View More
          </Button>

          <Button
            style={{
              backgroundColor: inWorkspace ? '#664A00' : '#996B00',
              marginRight: '4px',
              border: 'none',
            }}
            onClick={() => {
              if (checkInWorkspace(dataset)) {
                removeFromWorkspace(dataset);
              } else {
                addToWorkspace(dataset);
              }
            }}
            disabled={!itemGis}
          >
            {inWorkspace ? 'Remove from  Map Viewer' : 'Add to  Map Viewer'}
          </Button>

          <Button
            style={{
              backgroundColor: '#3f7c85',
              marginRight: '4px',
              border: 'none',
            }}
            onClick={handleApisView}
            disabled={!itemGis}
          >
            APIs
          </Button>
          <Button
            style={{
              backgroundColor: '#2c3e37',
              marginRight: '4px',
              border: 'none',
            }}
            onClick={handleDownload}
            disabled={loading || !itemGis}
          >
            {loading && (
              <>
                <Spinner animation="border" size="sm" aria-hidden="true" />{' '}
                <span className="visually-hidden">Downloading…</span>
              </>
            )}
            Download{isBoundary ? ' GeoJSON' : isITS ? ' GDB' : ' Zip'}
          </Button>
        </div>
        <DownloadStatus status={downloadStatus} error={downloadError} />
      </div>
    </div>
  );
};
export default ListCardBasic;
